import { render, staticRenderFns } from "./ChooseReplyTemplate.vue?vue&type=template&id=1f8eca1a&scoped=true&"
import script from "./ChooseReplyTemplate.vue?vue&type=script&lang=js&"
export * from "./ChooseReplyTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChooseReplyTemplate.vue?vue&type=style&index=0&id=1f8eca1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8eca1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
